// extracted by mini-css-extract-plugin
export default {"moduleList":"ModuleList__moduleList__SfHB8"};